<template>
  <div class="back">
<!--      <div class="header">-->
<!--        <img src="../png/qssyLogo.jpg" @click="handleBack" style="width: 200px;float: left;margin-left: 5%;  padding-top: 1%; cursor: pointer;"/>-->
<!--        &lt;!&ndash;      <p>|</p>&ndash;&gt;-->
<!--        &lt;!&ndash;      <span style="float: left;font-size: 24px;padding-top: 2%"> | 廉洁举报平台</span>&ndash;&gt;-->

<!--      </div>-->
    <div style="width: 75%;margin-left: 13%;margin-top: 4%">
      <h1 style="text-align: left">常见问题</h1>
      <div style="text-align: left">
        <b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1、青山实业廉洁监察部的相关情况？</b>
        <p class="item">青山实业廉洁监察部是由青山集团董事局批准设立的、全面负责青山实业董事局、下属集团及其子公司、关联公司廉洁工作的专职机构，
          直接向董事局主席负责并汇报工作，具有高度的独立性，不受其他任何部门或人员干扰。部门成员来自纪委监委、公检法、海关等原政府部门，
          长期奋战在反腐一线，具有丰富的实战经验和扎实的理论功底，是一支作风硬派、素质优良的专业化队伍。廉洁监察部的主要职责包括：独立开展案件调查
          ，履行重大事项监督，系统化构建公司廉洁风险防控体系，保障公司业务长期稳健发展等。</p>
        <b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2、如何保护举报人权益？</b>
        <p class="item">廉洁监察部将举报的保密工作放在首位，对举报受理、调查、处置有严格的管控制度和规范流程，
          对举报人的信息及提供的举报材料均严格保密。我们坚决反对任何形式的打击报复行为，并将依据国家法律法规及青山实业相关制度从严从快处理；
          对涉嫌犯罪的，将依法移交司法机关追究当事人的法律责任。</p>
        <b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3、举报人在提交举报信息后又发现有新的材料或信息需要补充提供的，如何处理？</b>
        <p class="item">对有新的举报材料或信息需要补充的，可发送邮件至举报邮箱（jubao@tssgroup.com），
          或通过邮寄方式提交（收件地址：浙江省温州市龙湾区龙祥路2666号，青山实业董事局监察安全委员会 廉洁监察部收）。
          同时，建议举报人在补充材料中简要说明原举报主题，方便我们收集汇总。</p>
        <b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4、举报奖励如何确定和发放？</b>
        <p class="item">依据《青山实业举报人保护和奖励条例》有关规定，凡实名举报并经查证属实的，我们将给予举报人最高1000万元人民币的奖励。
          奖励具体数额将根据举报人提供的线索真实性、证据证明力、协助调查配合程度、追回赃款赃物金额等因素综合考虑并确定，再通过举报人认可的方式发放举报奖励。</p>
        <b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5、举报材料如何规范撰写？</b>
        <p class="item">举报材料是我们开展调查工作的基础。为规范举报，我们会提供举报材料的模板供参考，具体请点击<a style="color:#409EFF;text-decoration:none" href="./static/举报模板.docx">举报模板</a>。</p>
        <b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;6、举报人能否查询举报处理进度？</b>
        <p class="item">可以。举报人可通过来电、来信、来访或电子邮件等多种渠道向我们了解举报线索处理进度，我们将安排专人负责跟进并回复。
          通过青山实业廉洁举报平台提交的举报，系统将随机生成一串代码作为举报人查询处理进展的重要凭证，必要时，我们会在回复处置进度前核验该串代码以确认系举报者本人。
          此外，我们也会及时向举报人反馈处理结果，听取举报人对处理结果的意见和建议。</p>
      </div>
      <el-button style="margin-top: 1%;float:left;margin-left:45%;width: 10%" @click="handleBack" type="primary" size="medium" > 返回首页</el-button>
      <br><br>
      <div style="height: 30px;width: 100%">
         &ensp;
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "problem",
  methods:{
    handleBack(){
      this.$router.push({ name:'WebIndex'})
    },
  }
}
</script>

<style scoped>
.item{
  text-indent:2em;
  font-size: 14px;
}
.back{    /* div的CSS样式 */
  position : absolute;
  top:0;
  left: 0;
  width : 100%;
  height :100%;
  /*background: url("static/png/back.jpg");*/
  /*background-image: url("../png/back.jpg");*/
  /*background-size:100% 100%;*/
}
.header{
  width: 100%;
  height: 10%;
  background: white;
  border-bottom: 1px solid gainsboro;
}
</style>



// WEBPACK FOOTER //
// src/pages/web/problem.vue